// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"6c9492be","438":"387cc76a","706":"d8b53091","726":"479f0cb1","785":"c75e54b9"}[chunkId] + ".chunk.js";
};